export default __webpack_public_path__ + "static/media/graxalta_VES_mp4_webdesign2021_headeranimation_02.a6e9335e.mp4";